import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectClaimDailyGiftDataState } from '../state/dailyGift.slice';
import {
  selectDailyGift,
  selectDailyGiftStatus,
  selectDailyRewardsDataState,
} from '@bonanza-social/daily-rewards/state';

const useDailyGift = () => {
  const dailyGift = useSelector(selectDailyGift);
  const dailyGiftStatus = useSelector(selectDailyGiftStatus);
  const dailyGiftDataState = useSelector(selectDailyRewardsDataState);
  const claimDailyGiftDataState = useSelector(selectClaimDailyGiftDataState);

  const returnObj = useMemo(
    () => ({
      dailyGift,
      dailyGiftStatus,
      dailyGiftDataState,
      claimDailyGiftDataState,
    }),
    [dailyGift, dailyGiftStatus, dailyGiftDataState, claimDailyGiftDataState],
  );

  return returnObj;
};

export default useDailyGift;
